/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import Datetime from "react-datetime";
import moment from "moment-timezone";

import "react-datetime/css/react-datetime.css";
import * as S from "../../styles";

export interface IDatePickerProps {
    id: string;
    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    required?: boolean;
    onlyMonthyear?: boolean;
    placeholder?: string;
    disabled?: boolean;
    timeZone?: string;
    hasError?: boolean;
    onCompChange?(id: string, payload: any): void;
    isCurrentDate?: boolean;
    isFuture?: boolean;
    initialViewMode?: any;
}

export const DatePicker = ({
    id,
    label,
    labelColor,
    errorText,
    value,
    required,
    onlyMonthyear,
    placeholder,
    timeZone,
    disabled,
    isFuture,
    isCurrentDate,
    hasError,
    onCompChange,
    initialViewMode
}: IDatePickerProps) => {
    const [textValue, setTextValue] = useState(value ?? "");
    const [isInvalid, setInvalid] = useState(false);

    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
    }, [hasError]);

    const onChange = (id: string, e: any) => {
        setTextValue(e);
        onCompChange && onCompChange(id, moment(e).format("YYYY-MM-DD"));
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const isValidDate = (currentDate: moment.Moment) => {
        if (isCurrentDate) {
            const now = moment().startOf('day');
            return currentDate.isSameOrBefore(now);
        }
        if (isFuture) {
            const startOfCurrentMonth = moment().startOf('month');
            return currentDate.isSameOrAfter(startOfCurrentMonth);
        }
        else {
            return true;
        }
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className="mb-4 formgroup">
                {_renderLabelIf()}
                {/* <Datetime
                    displayTimeZone={timeZone}
                    timeFormat={false}
                    closeOnSelect={true}
                    dateFormat="DD/MM/YYYY"
                    initialViewMode={initialViewMode}
                    onChange={onChange.bind(null, id)}
                    isValidDate={isValidDate}
                    renderInput={(props, openCalendar) => (
                        // <InputGroup className="inputcontrol shadow-none">
                        //     <InputGroup.Text>
                        //         <CalendarIcon className="icon icon-xs" />
                        //     </InputGroup.Text>
                        <InputGroup>
                            <Form.Control
                                className="formcontrol shadow-none"
                                required={required}
                                type="text"
                                value={
                                    textValue
                                        ? timeZone
                                            ? moment
                                                .tz(textValue, timeZone)
                                                .format("DD/MM/YYYY")
                                            : moment(textValue).format(
                                                "DD/MM/YYYY"
                                            )
                                        : ""
                                }
                                placeholder="mm/dd/yyyy"
                                onFocus={openCalendar}
                                onChange={() => { }}
                                disabled={disabled}
                                isInvalid={isInvalid}
                            />
                            <InputGroup>{_renderErrorTextIf()}</InputGroup>
                        </InputGroup>
                    )}
                /> */}
                <Datetime
                    displayTimeZone={timeZone}
                    timeFormat={false}
                    closeOnSelect={true}
                    dateFormat={onlyMonthyear ? "MM/YYYY" : "DD/MM/YYYY"}
                    initialViewMode={onlyMonthyear ? "years" : initialViewMode}
                    onChange={onChange.bind(null, id)}
                    isValidDate={isValidDate}
                    renderInput={(props, openCalendar) => (
                        <InputGroup>
                            <Form.Control
                                className="formcontrol shadow-none"
                                required={required}
                                type="text"
                                value={
                                    textValue
                                        ? timeZone
                                            ? moment
                                                .tz(textValue, timeZone)
                                                .format(onlyMonthyear ? "MM/YYYY" : "DD/MM/YYYY")
                                            : moment(textValue).format(
                                                onlyMonthyear ? "MM/YYYY" : "DD/MM/YYYY"
                                            )
                                        : ""
                                }
                                placeholder={onlyMonthyear ? "mm/yyyy" : "mm/dd/yyyy"}
                                onFocus={openCalendar}
                                onChange={() => { }}
                                disabled={disabled}
                                isInvalid={isInvalid}
                            />
                            <InputGroup>{_renderErrorTextIf()}</InputGroup>
                        </InputGroup>
                    )}
                />
            </Form.Group>
        </>
    );
};

DatePicker.defaultProps = {
    required: false,
    disabled: false,
    hasError: false,
    timeZone: null,
    initialViewMode: "years",
    isCurrentDate: true,
    isFuture: false,
    onlyMonthyear: false
};
